import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Button, Flex, Text } from "pcln-design-system";
import { ChatBubble } from "pcln-icons";
import react, { useCallback, useMemo } from "react";
import styled_components from "styled-components";
import { useChatUIContext } from "../../hooks/useChatUIContext.js";
import { inlineMetadataManager } from "../MarkdownComponent/MetadataManager.js";
import { useGoogleMapsHooks } from "./useGoogleMapsHooks.js";
const RelativeBox = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "GoogleMapComponents__RelativeBox"
})([
    "position:relative;z-index:1000;"
]);
const CloseMapButton = /*#__PURE__*/ styled_components(Button).withConfig({
    displayName: "GoogleMapComponents__CloseMapButton"
})([
    "position:absolute;top:16px;right:16px;"
]);
const GoogleMapComponents = /*#__PURE__*/ react.memo(({ mapContainerStyle = {
    height: 'calc(100% - 60px)',
    width: '100%'
}, buttonStyle = {
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translate(-50%, -15px)'
}, setiValues })=>{
    const hotelOnMapList = inlineMetadataManager.getHotelOnMapList();
    const locationPinList = inlineMetadataManager.getLocationPinList();
    const { setIsMapOpened, isMapOpened, shouldDisplayMapButton } = useChatUIContext();
    const hotelPinsOnMap = useMemo(()=>hotelOnMapList?.reduce((acc, curr)=>{
            if (curr?.hotel?.hotelType !== 'SOPQ') acc[curr.name] = {
                ...curr
            };
            return acc;
        }, {}), [
        hotelOnMapList
    ]);
    const locationPinsOnMap = locationPinList.filter((pin)=>{
        if (pin?.hotelId) {
            const hasDuplicatePin = hotelOnMapList.some((hotel)=>hotel?.hotel?.hotelId === pin.hotelId);
            return !hasDuplicatePin;
        }
        return true;
    })?.reduce((acc, curr)=>{
        acc[curr.name] = {
            ...curr
        };
        return acc;
    }, {});
    useGoogleMapsHooks({
        hotelPinsOnMap,
        locationPinsOnMap,
        setiValues
    });
    const handleOnClick = useCallback(function(event) {
        event.preventDefault();
        event.stopPropagation();
        setIsMapOpened(false);
    }, [
        setIsMapOpened
    ]);
    return /*#__PURE__*/ jsxs(react.Fragment, {
        children: [
            isMapOpened && shouldDisplayMapButton && /*#__PURE__*/ jsx(RelativeBox, {
                children: /*#__PURE__*/ jsx(CloseMapButton, {
                    title: "Close Map",
                    variation: "white",
                    color: "primary",
                    size: "small",
                    onClick: handleOnClick,
                    children: "Close Map"
                })
            }),
            /*#__PURE__*/ jsx("div", {
                style: mapContainerStyle,
                id: "PENNY-SEARCH-GOOGLE-MAP"
            }),
            shouldDisplayMapButton && /*#__PURE__*/ jsx(Button, {
                size: "small",
                style: buttonStyle,
                onClick: handleOnClick,
                title: "Close Map",
                children: /*#__PURE__*/ jsxs(Flex, {
                    children: [
                        /*#__PURE__*/ jsx(ChatBubble, {
                            color: "lightest",
                            size: 16
                        }),
                        /*#__PURE__*/ jsx(Text, {
                            ml: 1,
                            children: "Chat"
                        })
                    ]
                })
            })
        ]
    });
});
GoogleMapComponents.displayName = 'GoogleMapComponents';
const Maps_GoogleMapComponents = GoogleMapComponents;
export { Maps_GoogleMapComponents as default };
